import { demoBookings, demoGalleries, demoPackages, demoReviews, demoSettings } from './demoData';
import type { Booking, ClientGallery, GalleryStatus, Package, Review, StudioSettings } from '../types';

const KEY = 'pawtrait-demo-db-v1';
interface DemoDb { galleries: ClientGallery[]; packages: Package[]; bookings: Booking[]; reviews: Review[]; settings: StudioSettings; }

function load(): DemoDb {
  const raw = localStorage.getItem(KEY);
  if (raw) return JSON.parse(raw) as DemoDb;
  const seed = structuredClone({ galleries: demoGalleries, packages: demoPackages, bookings: demoBookings, reviews: demoReviews, settings: demoSettings });
  localStorage.setItem(KEY, JSON.stringify(seed));
  return seed;
}
function save(db: DemoDb) { localStorage.setItem(KEY, JSON.stringify(db)); window.dispatchEvent(new Event('pawtrait-db')); }

export const demoStore = {
  getDb: load,
  saveDb: save,
  getGallery(galleryId: string, pin?: string) {
    const gallery = load().galleries.find(g => g.galleryId.toUpperCase() === galleryId.toUpperCase());
    if (!gallery) return null;
    if (gallery.pin && gallery.pin !== pin) return null;
    return gallery;
  },
  updateSelections(galleryId: string, selectedIds: string[]) {
    const db = load(); const g = db.galleries.find(x => x.galleryId === galleryId); if (!g || g.selectionLocked) return g || null;
    g.photos.forEach(p => { p.selected = selectedIds.includes(p.id); }); save(db); return g;
  },
  submitSelection(galleryId: string) {
    const db = load(); const g = db.galleries.find(x => x.galleryId === galleryId); if (!g) return null;
    g.selectionLocked = true; g.status = 'waiting_editing'; save(db); return g;
  },
  reportPayment(galleryId: string) {
    const db = load(); const g = db.galleries.find(x => x.galleryId === galleryId); if (!g) return null;
    g.paymentStatus = 'client_reported'; save(db); return g;
  },
  addBooking(booking: Booking) { const db = load(); db.bookings.unshift(booking); save(db); },
  addReview(review: Review) { const db = load(); db.reviews.unshift(review); save(db); },
  updateGalleryStatus(id: string, status: GalleryStatus) { const db = load(); const g = db.galleries.find(x => x.id === id); if (g) { g.status = status; save(db); } },
  reopenSelection(id: string) { const db = load(); const g = db.galleries.find(x => x.id === id); if (g) { g.selectionLocked = false; g.status = 'selection_open'; save(db); } },
  deleteGallery(id: string) { const db = load(); db.galleries = db.galleries.filter(g => g.id !== id); save(db); },
  setPaymentReceived(id: string) { const db = load(); const g = db.galleries.find(x => x.id === id); if (g) { g.paymentStatus = 'received'; save(db); } },
  approveReview(id: string) { const db = load(); const r = db.reviews.find(x => x.id === id); if (r) { r.approved = true; save(db); } },
  updateBookingStatus(id: string, status: Booking['status']) { const db = load(); const b = db.bookings.find(x => x.id === id); if (b) { b.status = status; save(db); } }
};
